import ACTIONS from "../Actions/projectKind.json";
import {
  LOAD_SIDE,
  LINE_SIDE,
  NEW_SWICTHBOARD,
  EXISTING_SWICTHBOARD,
  MGAAS_ANSI,
  MGaaS_A2E,
  MGaaS_IEC,
  DAAS_ANSI,
  DAAS_IEC,
  GRID_CONNECTED,
  GRID_CONNECTED_GSX,
  ISLANDABLE,
  ISLANDABLE_GSX,
  GREENSTRUXURE,
  PV_GENSET_ATS,
  PV_BESS_NR,
  PV_HYBRIDIZATION,
  GENSET_PVBESS_A2E,
  NO_FUEL,
  GENERIC,
  GREENSTRUXURE_MICROGRID,
  FUEL_SAVER,
  GENSET_MAIN_NO_BESS,
  ETO,
  MGAAS_ETO,
  DAAS_ETO,
  NMGAAS_ETO,
  NMGAAS_ETO_EMOL,
  OFF_GRID,
} from "../../../utils/application.constants";
import { getProjectTypeValue } from "../../../utils/project";
let projectTypeData = getProjectTypeValue();

const initialTypes = {
  //  project type :MGAAS_ANSI
  isMgaasAnsi: projectTypeData === MGAAS_ANSI,
  isMgaasAnsiGrid: false,
  isMgaasAnsiIsland: false,
  isMgaasAnsiOffGrid: false,

  //  project type : MGaaS_IEC
  isMgaasIec: projectTypeData === MGaaS_IEC,
  isMgaasIecGrid: false,
  isMgaasIecIsland: false,
  isMgaasIecOffGrid: false,

  //  project type : MGAAS_ETO
  isMGaaSETO: projectTypeData === MGAAS_ETO,
  isMGaaSETOGrid: false,
  isMGaaSETOIsland: false,
  isMGaaSETOGensetPvHybrid: false,
  isMassEtoOffGrid: false,

  //  project type : NMGAAS_ETO
  isNMGaaSETO: projectTypeData === NMGAAS_ETO,
  isNMGaaSETOGrid: false,
  isNMGaaSETOIsland: false,
  isNMGaaSETOOFF: false,
  isNMGaaSETOGensetPvHybrid: false,

  // project type : NMGAAS_ETO_EMOL
  isNMGaaSETOEMOL: projectTypeData === NMGAAS_ETO_EMOL,
  isNMGaaSETOEMOLGrid: false,
  isNMGaaSETOEMOLIsland: false,
  isNMGaaSETOEMOLGensetPvHybrid: false,

  //  project type : DAAS_ANSI
  isDaasAnsi: projectTypeData === DAAS_ANSI,
  isDaasAnsiGrid: false,
  isDaasAnsiIsland: false,

  //  project type : DAAS_IEC
  isDaasIec: projectTypeData === DAAS_IEC,
  isDaasIecGrid: false,
  isDaasIecIsland: false,

  //  project type : DAAS_ETO
  isDaasEto: projectTypeData === DAAS_ETO,
  isDaasEtoGrid: false,
  isDaasEtoIsland: false,

  isGridConnected: false,
  isGridConnectedGSX: false,
  isIslandable: false,
  isIslandableGSX: false,

  isA2E: projectTypeData === MGaaS_A2E,
  isLineSide: false,
  isExistingSwitchBoard: false,
  isLoadSide: false,
  isNewSwitchBoard: false,
  isGreenStruxure: false,
  isGeneric: false,
  isGreenStruxureMicrogrid: false,
  isPVGensetATS: false,
  isFuelSaver: false,
  isPVBessNR: false,
  isPVHybrid: false,
  isPVGensetA2E: false,
  isGensetMainNoBess: false,
  isNoFuel: false,


  gridSettings: {},
  defaultValues: {},
  defaults: {},
  isAnsi: false,
  isIec: false,
  isEto: false,
};

const projectKindReducer = (state, action) => {
  let {
    connectionType,
    siteType,
    switchboardType,
    clientType,
    architecture,
    gridSettings: { mode = "" } = {},
    gridSettings = {},
    defaultValues = {},
    defaults = {},
    projectTypeValue = getProjectTypeValue(),
  } = action.payload;
  switch (action.type) {
    case ACTIONS.UPDATE_PROJECT_KIND:
      return {
        ...state,

        isMgaasAnsi: projectTypeValue === MGAAS_ANSI || false,
        isDaasAnsi: projectTypeValue === DAAS_ANSI || false,
        isDaasEto: projectTypeValue === DAAS_ETO || false,
        isMgaasIec: projectTypeValue === MGaaS_IEC || false,
        isDaasIec: projectTypeValue === DAAS_IEC || false,
        isDaasAnsiGrid:
          (projectTypeValue === DAAS_ANSI && siteType === GRID_CONNECTED_GSX) ||
          false,
        isDaasIecIsland:
          (projectTypeValue === DAAS_IEC && siteType === ISLANDABLE_GSX) ||
          false,
        isDaasEtoGrid:
          (projectTypeValue === DAAS_ETO && siteType === GRID_CONNECTED_GSX) ||
          false,
        isDaasEtoIsland:
          (projectTypeValue === DAAS_ETO && siteType === ISLANDABLE_GSX) ||
          false,
        isMgaasAnsiGrid:
          (projectTypeValue === MGAAS_ANSI && siteType === GRID_CONNECTED) ||
          false,

        isMgaasAnsiIsland:
          (projectTypeValue === MGAAS_ANSI && siteType === ISLANDABLE) || false,
        isDaasAnsiIsland:
          (projectTypeValue === DAAS_ANSI && siteType === ISLANDABLE_GSX) ||
          false,
        isMgaasIecGrid:
          (projectTypeValue === MGaaS_IEC && siteType === GRID_CONNECTED) ||
          false,
        isDaasIecGrid:
          (projectTypeValue === DAAS_IEC && siteType === GRID_CONNECTED_GSX) ||
          false,
        isMgaasIecIsland:
          (projectTypeValue === MGaaS_IEC && siteType === ISLANDABLE) || false,
        isGridConnected: siteType === GRID_CONNECTED || false,
        isGridConnectedGSX: siteType === GRID_CONNECTED_GSX || false,
        isIslandable: siteType === ISLANDABLE || false,
        isIslandableGSX: siteType === ISLANDABLE_GSX || false,
        isA2E: projectTypeValue === MGaaS_A2E || false,
        isAnsi: [DAAS_ANSI, MGAAS_ANSI].includes(projectTypeValue || false),
        isIec: [DAAS_IEC, MGaaS_IEC].includes(projectTypeValue || false),
        isEto: [MGAAS_ETO].includes(projectTypeValue || false),
        isLineSide: connectionType === LINE_SIDE || false,
        isNewSwitchBoard: switchboardType === NEW_SWICTHBOARD || false,
        isLoadSide: connectionType === LOAD_SIDE || false,
        isExistingSwitchBoard:
          switchboardType === EXISTING_SWICTHBOARD || false,
        isMGaaSETO: projectTypeValue === MGAAS_ETO || false,

        isMGaaSETO: projectTypeValue === MGAAS_ETO || false,
        isMGaaSETOGrid: (projectTypeValue === MGAAS_ETO && siteType === GRID_CONNECTED) || false,
        isMGaaSETOIsland: (projectTypeValue === MGAAS_ETO && siteType === ISLANDABLE) || false,
        isMGaaSETOGensetPvHybrid: (projectTypeValue === MGAAS_ETO && siteType === PV_HYBRIDIZATION) || false,

        isNMGaaSETO: projectTypeValue === NMGAAS_ETO || false,
        isNMGaaSETOGrid: (projectTypeValue === NMGAAS_ETO && siteType === GRID_CONNECTED) || false,
        isNMGaaSETOIsland: (projectTypeValue === NMGAAS_ETO && siteType === ISLANDABLE) || false,
        isNMGaaSETOGensetPvHybrid: (projectTypeValue === NMGAAS_ETO && siteType === PV_HYBRIDIZATION) || false,

         isNMGaaSETOEMOL: projectTypeValue === NMGAAS_ETO_EMOL || false,
        isNMGaaSETOEMOLGrid: (projectTypeValue === NMGAAS_ETO_EMOL && siteType === GRID_CONNECTED) || false,
        isNMGaaSETOEMOLIsland: (projectTypeValue === NMGAAS_ETO_EMOL && siteType === ISLANDABLE) || false,
        isNMGaaSETOEMOLOFF: (projectTypeValue === NMGAAS_ETO_EMOL && siteType === OFF_GRID) || false,
        isNMGaaSETOEMOLGensetPvHybrid: (projectTypeValue === NMGAAS_ETO_EMOL && siteType === PV_HYBRIDIZATION) || false,

        // OFF_GRID
        isMgaasAnsiOffGrid: (projectTypeValue === MGAAS_ANSI && siteType === OFF_GRID) || false,
        isMgaasIecOffGrid: (projectTypeValue === MGaaS_IEC && siteType === OFF_GRID) || false,
        isMassEtoOffGrid: (projectTypeValue === MGAAS_ETO && siteType === OFF_GRID) || false,

      };
    case ACTIONS.RESET_PROJECT_KIND:
      return initialTypes;
    case ACTIONS.UPDATE_DEFAULT_PROJECT_KIND:
      let defaultsData = {};
      for (let defaultData of defaults) {
        defaultsData[defaultData["param"]] = defaultData["value"];
      }
      return {
        ...state,
        isGreenStruxure: clientType === GREENSTRUXURE || false,
        isGeneric: clientType === GENERIC || false,
        isGreenStruxureMicrogrid:
          clientType === GREENSTRUXURE_MICROGRID || false,
        isPVGensetATS: architecture === PV_GENSET_ATS || false,
        isFuelSaver: mode === FUEL_SAVER || false,
        isPVBessNR: architecture === PV_BESS_NR || false,
        isPVHybrid: siteType === PV_HYBRIDIZATION || false,
        isPVGensetA2E: siteType === GENSET_PVBESS_A2E || false,
        isGensetMainNoBess: mode === GENSET_MAIN_NO_BESS || false,
        isNoFuel: mode === NO_FUEL || false,
        gridSettings: gridSettings || {},
        defaultValues: defaultValues || {},
        defaults: defaults || {},
        defaultKeyValuePairs: defaultsData || {},
      };
    default:
      return state;
  }
};

export { initialTypes, projectKindReducer };
